enum MessageTypes {
  ALERT = 'THIRD-PARTY-APP.ALERT',
  INTERACTION_EVENT = 'THIRD-PARTY-APP.INTERACTION_EVENT',
  LOADED = 'THIRD-PARTY-APP.LOADED',
  LOGOUT = 'THIRD-PARTY-APP.LOGOUT',
  REDIRECT = 'THIRD-PARTY-APP.REDIRECT',
  LOADED_LISTENER = 'LOADED_LISTENER',
  VLC_LANG_UPDATE = 'VLC.LANG_UPDATE',
  VLC_PATH_UPDATE = 'VLC.PATH_UPDATE',
  WINDOW_CLICK_LISTENER = 'WINDOW_CLICK_LISTENER',
  EXPIRED_TOKEN = 'THIRD-PARTY-APP.EXPIRED_TOKEN',
  ACTIVE_EXTENSIONS = 'THIRD-PARTY-APP.ACTIVE_EXTENSIONS',
  OPEN_PF_TOUR = 'THIRD-PARTY-APP.OPEN_PF_TOUR'
}

export { MessageTypes }
